import { AfterViewInit, Component, ViewChild } from '@angular/core';
import { ExcelService } from 'src/app/services/excel-service.service';
import { ProjectDataTableService } from './project-data-table.service';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';

@Component({
  selector: 'app-project-data-table',
  templateUrl: './project-data-table.component.html',
  styleUrls: ['./project-data-table.component.css']
})
export class ProjectDataTableComponent implements AfterViewInit {
  displayedColumns = ["clientName", "projectName", "managerId", "managerName"];
  loading: boolean = true;
  searchText: string = "";
  advancedSearchText: string = "";
  isProfileCompleted: boolean = true;
  from: any = 0;
  size: any = 5;
  totalRecords: any = 0;
  currentPage: Number = 0;
  isVisible = false;
  public dataSource: MatTableDataSource<any>;
  public profileCompletedCounts: any;
  searchfield: string = "";
  options = ['ClientName', 'ProjectName', 'ManagerId', 'ManagerName', 'Competency', 'PrimarySkills', 'SecondarySkills'];
  optionMapping = {
    'ClientName': 'Client Name',
    'ProjectName': 'Project Name',
    'ManagerId': 'Manager Id',
    'ManagerName': 'Manager Name',
    'Competency': 'Competency',
    'PrimarySkills': 'Primary Skills',
    'SecondarySkills': 'Secondary Skills'
  };
  selectedOption = '';
  enteredText = '';
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;


  constructor(private service: ProjectDataTableService, private excel: ExcelService) {
  }

  ngAfterViewInit() {
    //this.advancedSearchText= this.service.getSearchText();
    this.updateDisplayedColumns();
    this.getProjectData('', '');
    this.getProjectCompletedCounts();
  }
  openPopup() {
    this.isVisible = true;
  }

  closePopup() {
    this.isVisible = false;
  }
  search() {
    this.service.setSearchText(this.enteredText);
    this.advancedSearchText = this.service.getSearchText();
    const searchField = this.selectedOption;

    this.from = 0;
    this.size = 10;

    this.applyFilter(this.advancedSearchText, searchField);
    this.closePopup();
  }


  clearFilter() {
    this.selectedOption = '';
    this.enteredText = '';
    this.advancedSearchText = '';
    this.searchfield = '';
    this.from = 0;
    this.size = 10
    this.search();
  }
  searchButton() {
    if (this.advancedSearchText != '') {
      this.service.setSearchText(this.advancedSearchText);
      this.from = 0;
      this.size = 6;
      this.applyFilter(this.advancedSearchText, this.searchfield);
    }
    else {
      this.clearSearch()
    }
  }
  clearSearch() {
    if (this.advancedSearchText == "") {
      this.getProjectData(this.advancedSearchText, '');
    }
  }
  exportExcel(isProfileCompleted, size) {
    this.service.getProjectProfilesByStatuses("", "", isProfileCompleted, 0, size).subscribe(x => {
      let excelData = x.data.items.map(i => {
        i['Client Name'] = i.clientName;
        i['Project Name'] = i.projectName;
        i['Manager Id'] = i.managerId;
        i['Manager Name'] = i.managerName;


        delete i.clientName;
        delete i.projectName;
        delete i.managerId;
        delete i.managerName;
        delete i.clientId;
        delete i.projectId;
        delete i.isProjectFilled;


        return i;
      });

      this.excel.exportToExcel(isProfileCompleted ? this.flattenData(excelData) : excelData.map(x => { delete x.competencies; return x; }), isProfileCompleted ? 'Completed_employees' : 'Not_Started_Employees');
    });
  }
  getProjectData(searchText: string, searchField: string) {
    this.loading = true;
    return this.service.getProjectProfilesByStatuses(searchText, searchField, this.isProfileCompleted, this.from, this.size).subscribe(x => {
      this.dataSource = new MatTableDataSource(x.data.items);
      this.totalRecords = x.data.total;
      this.dataSource.sort = this.sort;
      this.loading = false;
    });
  }
  /**
   * Set the paginator and sort after the view init since this component will
   * be able to query its view for the initialized paginator and sort.
   */

  getdata() {
    this.updateDisplayedColumns();
    this.getProjectData(this.searchText, '');
  }
  getPaginatorData(event) {
    this.size = event.pageSize;
    this.from = event.pageIndex * this.size;
    const searchField = this.selectedOption;
    this.applyFilter(this.advancedSearchText, searchField);
  }

  getProjectCompletedCounts() {
    this.loading = true;
    this.service.getProjectCompletedCounts().subscribe(x => {
      this.profileCompletedCounts = x.data;
      this.loading = false;
    })
  }
  applyFilter(filterValue: string, searchField: string) {
    this.searchText = filterValue;
    // this.from = 0;
    // this.size = 10;
    this.getProjectData(filterValue, searchField);
  }
  flattenData(data) {
    let flattenedData = [];
    data.forEach(item => {
      let competencies = item.competencies;
      delete item.competencies;
      competencies?.forEach(competency => {
        let serviceLines = competency.serviceLines?.map(serviceLine => serviceLine.name).join(', ');
        let primarySkills = competency.primarySkills?.map(primarySkill => primarySkill.name).join(', ');
        let secondarySkills = competency.secondarySkills?.map(secondarySkill => secondarySkill.name).join(', ');
        delete competency.serviceLines;
        delete competency.primarySkills;
        delete competency.secondarySkills;
        flattenedData.push({
          ...item,
          ['Competency Name']: competency.name,
          ['Service Lines']: serviceLines,
          ['Most Used Skills']: primarySkills,
          ['Rarely Used Skills']: secondarySkills
        });
      });
    });
    return flattenedData;
  }

  updateDisplayedColumns() {
    this.enteredText = '';
    this.selectedOption = '';
    this.displayedColumns = ["clientName", "projectName", "managerId", "managerName"];
    this.options = ['ClientName', 'ProjectName', 'ManagerId', 'ManagerName'];
    if (this.isProfileCompleted) {
      this.displayedColumns.push("competency", "primarySkills", "secondarySkills");
      this.options.push('Competency', 'PrimarySkills', 'SecondarySkills');
    }
  }

  // Function to get competency names
  getCompetencyNames(row: any): string {
    if (row.competencies && row.competencies.length > 0) {
      return row.competencies
        .map(competency => competency.name)
        .join(', ');
    }
    return 'N/A';
  }

  // Function to get skills, if isPrimary is true returns primary skills else secondary skills
  getSkills(row: any, isPrimary: boolean): string {
    let skillType = isPrimary ? "primarySkills" : "secondarySkills";
    if (isPrimary && row.competencies && row.competencies.length > 0 && row.competencies.filter(x => x.primarySkills != null && x.primarySkills.length > 0).length > 0) {
      return row.competencies
        .flatMap(competency => competency.primarySkills ? competency.primarySkills.map(skill => skill.name) : [])
        .join(', ');
    }
    else if (!isPrimary && row.competencies && row.competencies.length > 0 && row.competencies.filter(x => x.secondarySkills != null && x.secondarySkills.length > 0).length > 0) {
      return row.competencies
        .flatMap(competency => competency.secondarySkills ? competency.secondarySkills.map(skill => skill.name) : [])
        .join(', ');
    }
    return 'N/A';
  }
}
